import { render, staticRenderFns } from "./ProjectorInfo.vue?vue&type=template&id=4edd288c&scoped=true&"
import script from "./ProjectorInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectorInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectorInfo.vue?vue&type=style&index=0&id=4edd288c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edd288c",
  null
  
)

export default component.exports